import React from 'react';
import PropTypes from 'prop-types';
import classes from './invoices.module.scss';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/arrow_sort.svg';
import utils from '../../../../utils/utils';
import Menu from '../../../_common/Menu/Menu';

const InvoiceTable = ({
  data, header, className = '', onClick = () => {}, sort, sortBy, onSortBy,
  menuOptions, onMenuSelect, menuLoadingIds = [],
}) => {
  const onSort = (currentSortBy) => {
    const newSortType = { sortBy: currentSortBy, sort: 'asc' };

    if (sortBy === currentSortBy) {
      newSortType.sort = sort === 'desc' ? 'asc' : 'desc';
    }

    onSortBy(newSortType);
  };

  const trClass = [classes.tr];
  if (className) trClass.push(className);

  const arrowIcon = [classes.arrow_icon];
  if (sort === 'desc') arrowIcon.push(classes.arrow_icon_desc);

  return (
    data.length
      ? (
        <div className={classes.table_wrapper}>
          <div className={classes.table__border}>
            <table className={classes.table}>

              <thead className={classes.thead}>
                <tr className={classes.tr}>
                  {header.map((h) => (
                    <th
                      key={h.name}
                      className={[classes.th, h.isSelectable ? classes.th_selectable : null].join(' ')}
                      onClick={() => h.isSelectable && onSort(h.path)}
                    >
                      <span className={classes.th_title}>
                        {h.name}

                        <span className={classes.th_arrow}>
                          {h.isSelectable && h.path === sortBy && (
                          <ArrowIcon className={arrowIcon.join(' ')} />
                          )}
                        </span>
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={classes.tbody}>
                {data.map((d, i) => (
                  <tr
                    className={trClass.join(' ')}
                    onClick={() => d.payments.length && onClick(d)}
                    key={`${d.name} ${i}`}
                    style={{cursor: d.payments.length ? 'pointer' : 'auto'}}
                  >

                    {header.map((h) => (
                      <td className={classes.td} key={h.name}>
                        {h.type === 'action'
                          ? (
                            <Menu
                              options={menuOptions(d)}
                              onChange={(menuOption) => onMenuSelect(menuOption, d)}
                              loading={menuLoadingIds.includes(d.id)}
                            />
                          )

                          : h.type === 'currency'
                            ? utils.formattingCurrency(d[h.path])

                            : (d[h.path] ?? ' - ')}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )

      : <div className={classes.notResult}>No Data Found</div>
  );
};

InvoiceTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortBy: PropTypes.func,
};

export default InvoiceTable;
